export default __webpack_public_path__ + "static/media/eye.1667f5f4.svg";